import { client } from '@/config/apollo/apollo'
import { FeatureFlagsDocument } from '@/graphql/generated/hooks'

const MEMORY_ONLY_TOKEN_FLAG_SUFFIX =
  '/features/enabled/memory-only-token-storage'

const CACHE_TTL_MS = 60_000

let lastFetchedAt = 0
let isFlagEnabled = false
let inFlightRequest: Promise<boolean> | null = null

const readFlagValue = (
  flags: Array<{ name?: string; value?: string }>
): boolean => {
  const match = flags.find((flag) =>
    flag?.name?.endsWith(MEMORY_ONLY_TOKEN_FLAG_SUFFIX)
  )

  return match?.value === 'true'
}

export const getCachedMemoryOnlyTokenStorageFlag = (): boolean => isFlagEnabled

export const fetchMemoryOnlyTokenStorageFlag = async (
  accessToken: string | null,
  force = false
): Promise<boolean> => {
  // Avoid unauthenticated FF requests during early boot.
  if (!accessToken) return isFlagEnabled

  const isCacheValid = Date.now() - lastFetchedAt < CACHE_TTL_MS

  if (!force && isCacheValid) {
    return isFlagEnabled
  }

  if (inFlightRequest) {
    return inFlightRequest
  }

  inFlightRequest = client
    .query({
      query: FeatureFlagsDocument,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const flags = data?.featureFlags ?? []
      isFlagEnabled = readFlagValue(flags)
      lastFetchedAt = Date.now()
      return isFlagEnabled
    })
    .catch(() => {
      // Keep last known mode on fetch failure.
      lastFetchedAt = Date.now()
      return isFlagEnabled
    })
    .finally(() => {
      inFlightRequest = null
    })

  return inFlightRequest
}
